import SendEmail from "../../components/SendEmail";

const ContactPreview = () => {
  return (
    <article className="contact">
      <h2 className="title-font pink-text h2-tag">Contact Me</h2>
      <p className="white-text p-tag">
      If you are interested in hiring me or have any other requests or questions regarding embedded software development, 
      feel free to reach out. I am always open to new opportunities and interesting projects
      </p>
      <SendEmail />
    </article>
  );
};

export default ContactPreview;
